import * as React from "react";
import { Form } from "antd";
import { css, InterpolationWithTheme } from "@emotion/core";
import { ReactNode } from "react";

type Props = {
  label: string;
  annotation: ReactNode;
  children: JSX.Element;
  itemCss?: InterpolationWithTheme<any>;
};

export const AnnotatedFormItem = ({
  label,
  annotation,
  children,
  itemCss
}: Props) => (
  <div
    css={css`
      position: relative;
    `}
  >
    <Form.Item label={label} css={itemCss}>
      {children}
      <small
        css={css`
          display: none;
          font-size: 9px;
          line-height: 12px;

          @media (min-width: 576px) {
            display: block;
          }
        `}
      >
        {annotation}
      </small>
    </Form.Item>
    <small
      css={css`
        position: absolute;
        right: 0;
        top: 3px;
        font-size: 9px;
        line-height: 12px;

        @media (min-width: 576px) {
          display: none;
        }
      `}
    >
      {annotation}
    </small>
  </div>
);
